<template>
  <div id="app">
    <Vheader />

    <main class="container-fluid">
      <contact/>
      <router-view></router-view>
    </main>

    <VFooter />
  </div>
</template>

<script>
import Vheader from './components/Header/Vheader'
import VFooter from './components/Footer/VFooter'
import Contact from "./components/Core/Contact"

export default {
  name: 'app',
  components: {
    Contact,
    Vheader,
    VFooter
  },
  watch:{
    $route (to, from){
      // Analytics - when the page url is changed (no http)
      if (typeof _paq != "undefined") {
        var profile = this.$cookies.isKey('profile') ? this.$cookies.get('profile') : 'Unknown';
        _paq.push(['setCustomDimension', '1', profile]);
        _paq.push(['setCustomUrl', to.fullPath]);
        _paq.push(['trackPageView']);
      }
    }
  },
  created: function() {
    // Analytics - when the page is loaded (http)
    if (typeof _paq != "undefined") {
      var profile = this.$cookies.isKey('profile') ? this.$cookies.get('profile') : 'Unknown';
      _paq.push(['setCustomDimension', '1', profile]);
      _paq.push(['trackPageView']);
    }
  }
}
</script>

<style lang="scss">

  html {
    height: 100vh;
    background:color(back);

    body {
      margin: 0;
      padding: 0;

      #app {
        text-align: center;
        margin: 0 auto;
        height: 100vh;

        .container-fluid {
          padding-left: 0;
          padding-right: 0;
          margin-left: auto;
          margin-right: auto;
          max-width: 1440px;

          section {
            padding: rem(40px) rem(135px);

            @include mq($from: MD, $until: LG) {
              padding: rem(30px) rem(30px);
            }

            @include mq($until: MD) {
              padding: rem(30px) 1px ;
            }
          }

          *[class^="col"]{
            position: inherit;
          }
        }
      }
    }
  }

</style>
